module.exports = __webpack_public_path__ + "static/media/mastercard.7c20c640.svg";